"use client";

import { useState } from "react";
import { motion } from "framer-motion";
import { Eye, EyeOff, User, Lock } from "lucide-react";
import toast from "react-hot-toast";
import Logo from "../../../assets/img/logo/logo.png";
import video from "../../../assets/video/new.mp4";
import { useAuth } from "../../../context/AdminAuthContext";
import { loginMaintainer } from "../../../services/maintainerServices";

const MaintainerLoginCom = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await loginMaintainer({ email: username, password });
      login({
        token: res.data.token,
        email: res.data.email,
        role: "maintainer",
        userId: res.data.userId,
        expireTime: res.data.expiresIn,
      });
      toast.success("Login successful!");
    } catch (error) {
      toast.error(error.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      className="min-h-screen flex bg-[#F3EFFF]"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="w-10/12 relative min-h-screen">
        <div className="absolute inset-0 w-full h-full">
          <video className="w-full h-full object-cover" autoPlay loop muted>
            <source src={video} type="video/mp4" />
          </video>
          <div className="absolute inset-0 bg-blue-900 opacity-50 z-0"></div>
        </div>

        <div className="absolute inset-0 flex flex-col justify-center max-w-lg items-start p-12 z-10 text-white">
          <div className="circle-loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <h1 className="text-[48px] text-white font-bold mb-2 mt-7">
            Hello SAP..!
          </h1>
          <div className="text-2xl font-normal tracking-wider">
            Manage members, events, and insights for a better aquatic future.
          </div>
        </div>
      </div>

      <div className="w-1/2 flex flex-col justify-center items-center p-12">
        <form className="w-full max-w-sm space-y-6" onSubmit={handleLogin}>
          <div className="text-center mb-8">
            <div className="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center mx-auto mb-4">
              <img src={Logo} alt="logo" className="w-[50px] object-cover" />
            </div>
            <h2 className="text-[28px] font-bold text-black mb-2">
              Welcome Back..!
            </h2>
          </div>

          <div>
            <label className="block text-base font-bold text-black mb-2">
              Email Id
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <User className="h-5 w-5 text-black" />
              </div>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="johe2@gmail.com"
                className="w-full pl-11 pr-12 py-3 border font-normal text-black border-[#20202030] rounded-lg focus:outline-none focus:border-none focus:ring-2 focus:ring-darkblue bg-white"
                required
              />
            </div>
          </div>

          <div>
            <label className="block text-base font-bold text-black mb-2">
              Password
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Lock className="h-5 w-5 text-black" />
              </div>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="********"
                className="w-full pl-11 pr-12 py-3 border font-normal text-black border-[#20202030] rounded-lg focus:outline-none focus:border-none focus:ring-2 focus:ring-darkblue bg-white"
                required
              />
              <button
                type="button"
                className="absolute inset-y-0 right-0 pr-3 flex items-center"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? (
                  <EyeOff className="h-5 w-5 text-gray-400 hover:text-gray-600" />
                ) : (
                  <Eye className="h-5 w-5 text-gray-400 hover:text-gray-600" />
                )}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-darkblue text-base font-medium rounded-md flex justify-center items-center py-[12px] text-white transition-colors"
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </motion.div>
  );
};

export default MaintainerLoginCom;
